import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c091dfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row card mb-5" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-5 align-items-center\" data-v-3c091dfd><div data-v-3c091dfd><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-3c091dfd><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-3c091dfd></rect><path d=\"M31.0836 25.2036L29.2696 24.0877C29.4527 23.0353 29.4527 21.9556 29.2696 20.9032L31.0836 19.7873C31.2923 19.6603 31.386 19.3972 31.3178 19.1522C30.8452 17.5373 30.0404 16.0766 28.9886 14.8609C28.8268 14.6749 28.5628 14.6296 28.3584 14.7566L26.5444 15.8725C25.7822 15.1739 24.905 14.6341 23.9555 14.2803V12.053C23.9555 11.7989 23.7894 11.5767 23.5552 11.5222C21.9924 11.1502 20.3914 11.1684 18.9053 11.5222C18.6711 11.5767 18.505 11.7989 18.505 12.053V14.2848C17.5597 14.6432 16.6825 15.183 15.9161 15.877L14.1063 14.7611C13.8977 14.6341 13.6379 14.6749 13.4761 14.8655C12.4244 16.0766 11.6196 17.5373 11.1469 19.1568C11.0745 19.4017 11.1725 19.6648 11.3811 19.7918L13.1951 20.9078C13.012 21.9602 13.012 23.0398 13.1951 24.0922L11.3811 25.2082C11.1725 25.3352 11.0788 25.5983 11.1469 25.8432C11.6196 27.4581 12.4244 28.9188 13.4761 30.1345C13.6379 30.3205 13.9019 30.3659 14.1063 30.2389L15.9203 29.123C16.6825 29.8215 17.5597 30.3614 18.5093 30.7152V32.947C18.5093 33.2011 18.6753 33.4233 18.9095 33.4778C20.4723 33.8498 22.0734 33.8316 23.5595 33.4778C23.7936 33.4233 23.9597 33.2011 23.9597 32.947V30.7152C24.905 30.3568 25.7822 29.817 26.5487 29.123L28.3627 30.2389C28.5713 30.3659 28.8311 30.3251 28.9929 30.1345C30.0446 28.9234 30.8494 27.4627 31.3221 25.8432C31.386 25.5937 31.2923 25.3306 31.0836 25.2036ZM21.2302 26.1245C19.3524 26.1245 17.8237 24.496 17.8237 22.4955C17.8237 20.495 19.3524 18.8664 21.2302 18.8664C23.1081 18.8664 24.6368 20.495 24.6368 22.4955C24.6368 24.496 23.1081 26.1245 21.2302 26.1245Z\" fill=\"#203972\" data-v-3c091dfd></path></svg></div><div data-v-3c091dfd><p class=\"m-0 subtitulo cor_texto_1\" data-v-3c091dfd>Config. Loja</p></div></div><div class=\"px-5\" data-v-3c091dfd><hr class=\"text-muted m-0\" data-v-3c091dfd></div>", 2)
const _hoisted_4 = { class: "container gap-4 p-5 mb-0" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_7 = { class: "fs-6 d-flex flex-row gap-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Produto principal", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fc0101"} }, "*", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 legenda text-danger" }, "Campo obrigatório", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["label", "value"]
const _hoisted_14 = ["label", "value"]
const _hoisted_15 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_16 = { class: "fs-6 d-flex flex-row gap-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Layout APP", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fc0101"} }, "*", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 legenda text-danger" }, "Campo obrigatório", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_23 = { class: "fs-6 d-flex flex-row gap-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Tipo de Oferta", -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fc0101"} }, "*", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 legenda text-danger" }, "Campo obrigatório", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "container gap-5 p-5 mb-0" }
const _hoisted_30 = { class: "row gap-4" }
const _hoisted_31 = { class: "row col-sm-6" }
const _hoisted_32 = { class: "d-flex flex-column gap-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Texto legal", -1))
const _hoisted_34 = { class: "row col-sm-6 gap-2 p-0 m-0" }
const _hoisted_35 = { class: "d-flex flex-column gap-1 p-sm-0" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Assinatura", -1))
const _hoisted_37 = { class: "d-flex flex-column gap-1 p-sm-0" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Rodapé Orçamento", -1))
const _hoisted_39 = {
  class: "row card mb-5",
  style: {"padding":"15px"}
}
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center\" style=\"gap:20px;\" data-v-3c091dfd><div data-v-3c091dfd><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-3c091dfd><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-3c091dfd></rect><path opacity=\"0.5\" d=\"M21.2326 33.4375C20.4559 33.4375 19.8285 32.7393 19.8285 31.875C19.8285 31.0107 20.4559 30.3125 21.2326 30.3125C22.0092 30.3125 22.6366 31.0107 22.6366 31.875C22.6366 32.7393 22.0092 33.4375 21.2326 33.4375Z\" fill=\"#203972\" data-v-3c091dfd></path><path d=\"M26.1468 10H16.3183C15.1556 10 14.2122 11.0498 14.2122 12.3438V32.6562C14.2122 33.9502 15.1556 35 16.3183 35H26.1468C27.3096 35 28.2529 33.9502 28.2529 32.6562V12.3438C28.2529 11.0498 27.3096 10 26.1468 10ZM21.2326 33.4375C20.456 33.4375 19.8285 32.7393 19.8285 31.875C19.8285 31.0107 20.456 30.3125 21.2326 30.3125C22.0092 30.3125 22.6367 31.0107 22.6367 31.875C22.6367 32.7393 22.0092 33.4375 21.2326 33.4375ZM26.1468 28.1641C26.1468 28.4863 25.9099 28.75 25.6203 28.75H16.8449C16.5553 28.75 16.3183 28.4863 16.3183 28.1641V12.9297C16.3183 12.6074 16.5553 12.3438 16.8449 12.3438H25.6203C25.9099 12.3438 26.1468 12.6074 26.1468 12.9297V28.1641Z\" fill=\"#203972\" data-v-3c091dfd></path></svg></div><div data-v-3c091dfd><p class=\"m-0 subtitulo cor_texto_1\" data-v-3c091dfd>Config. do App</p></div></div><div data-v-3c091dfd><hr class=\"text-muted\" style=\"margin:20px 0;\" data-v-3c091dfd></div>", 2)
const _hoisted_42 = {
  class: "d-flex flex-wrap justify-content-between",
  style: {"gap":"20px","font-size":"14px"}
}
const _hoisted_43 = { class: "justify-content-between rounded-2 flex-column card-item" }
const _hoisted_44 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Busca pela placa", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "m-0",
    style: {"color":"#B5B5C3"}
  }, " Habilita no app a funcionalidade de buscar o veículo pela placa. ")
], -1))
const _hoisted_48 = {
  class: "pt-3 texto",
  style: {"min-height":"50px"}
}
const _hoisted_49 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_50 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Pode alterar valor", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Permite que o usuário edite o preço na tela de cardápio. ")
], -1))
const _hoisted_54 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_55 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Formulário de recepção", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Começa o fluxo de atendimento com o formulário primeiro. ")
], -1))
const _hoisted_59 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_60 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Utiliza valor M.O", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Discrimina o valor de cada serviço separando Peça e M.O. ")
], -1))
const _hoisted_64 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_65 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Venda de óleo fracionado", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Adiciona um campo de edição na quantidade de óleo ao cardápio. ")
], -1))
const _hoisted_69 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_70 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Vende estoque negativo", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Não bloqueia a venda quando o produto está sem estoque. ")
], -1))
const _hoisted_74 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_75 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Pode dar desconto ", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Habilita a funcionalidade de aplicar desconto. ")
], -1))
const _hoisted_79 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#B5B5C3","border-top":"0.5px solid #ececf0","padding-top":"5px"} }, "Defina o limite em porcentagem", -1))
const _hoisted_81 = { class: "d-flex flex-row align-items-center" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col text-center",
  style: {"font-size":"18px"}
}, " % ", -1))
const _hoisted_83 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_84 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Habilitar Voucher ", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Habilita a funcionalidade de aplicar vouchers de desconto a cada consulta. ")
], -1))
const _hoisted_88 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_89 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Habilitar Campanha (0ferta é sua) ", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Habilita a funcionalidade de aplicar campanhas promocionais nos atendimentos. ")
], -1))
const _hoisted_93 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_94 = {
  class: "d-flex justify-content-between",
  style: {"gap":"20px","height":"35px"}
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Assinatura do cliente", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"15px 0"} }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#B5B5C3"} }, " Adiciona um campo na tela de atendimento para o cliente assinar. ")
], -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-nowrap",
  style: {"gap":"20px","font-size":"14px"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _hoisted_8,
              (!_ctx.produtoselect.toString().length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "rounded-2 bg-transparent",
              style: {"border":"0.5px solid #dfd8d8","height":"40px","padding-left":"10px"},
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.produtoselect) = $event))
            }, [
              (_ctx.configLoja.produtosPrincipal && _ctx.configLoja.produtosPrincipal.length > 0)
                ? (_openBlock(), _createElementBlock("option", {
                    key: 0,
                    label: _ctx.configLoja.produtosPrincipal[0]?.nome,
                    value: _ctx.configLoja.produtosPrincipal[0],
                    selected: ""
                  }, null, 8, _hoisted_13))
                : _createCommentVNode("", true),
              (_ctx.configLoja.produtosPrincipal && _ctx.configLoja.produtosPrincipal.length > 1)
                ? (_openBlock(), _createElementBlock("option", {
                    key: 1,
                    label: _ctx.configLoja.produtosPrincipal[1]?.nome,
                    value: _ctx.configLoja.produtosPrincipal[1]
                  }, null, 8, _hoisted_14))
                : _createCommentVNode("", true)
            ], 512), [
              [_vModelSelect, _ctx.produtoselect]
            ])
          ]),
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _hoisted_17,
              (!_ctx.layoutAppRef )
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.layoutAppRef,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.layoutAppRef) = $event)),
              placeholder: "Altere o layout"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configLoja.layoutApp, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.codBandeira,
                    label: item.descricao,
                    value: item.codBandeira
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("li", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _hoisted_24,
              (!_ctx.configLoja.tipoOferta.toString().length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.configLoja.tipoOferta,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.configLoja.tipoOferta) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Pacote oferta completo",
                  value: '1'
                }),
                _createVNode(_component_el_option, {
                  label: "Informação sobre o veiculo",
                  value: '2'
                }),
                _createVNode(_component_el_option, {
                  label: "Carrinho de compras",
                  value: '3'
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("li", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_el_input, {
                modelValue: _ctx.configLoja.textoLegal,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.configLoja.textoLegal) = $event)),
                rows: 6,
                type: "textarea",
                placeholder: "Insira um texto"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("li", _hoisted_35, [
              _hoisted_36,
              _createVNode(_component_el_input, {
                modelValue: _ctx.configLoja.assinatura,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configLoja.assinatura) = $event)),
                rows: 2,
                type: "textarea",
                placeholder: "Escreva..."
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("li", _hoisted_37, [
              _hoisted_38,
              _createVNode(_component_el_input, {
                modelValue: _ctx.configLoja.rodapeOrcamento,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.configLoja.rodapeOrcamento) = $event)),
                rows: 2,
                type: "textarea",
                placeholder: "Insira um texto"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _hoisted_40,
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.buscaPlaca,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.configLoja.buscaPlaca) = $event)),
              class: "ml-2",
              "active-value": 1,
              "inactive-value": 0,
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_46,
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            (_ctx.configLoja.buscaPlaca)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: _ctx.configLoja.fornecedorBuscaPlaca,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.configLoja.fornecedorBuscaPlaca) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.name
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.alterarValor,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.configLoja.alterarValor) = $event)),
              class: "ml-2",
              "active-value": "Sim",
              "inactive-value": "Não",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_52,
          _hoisted_53
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.formRecepcao,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.configLoja.formRecepcao) = $event)),
              class: "ml-2",
              "active-value": "S",
              "inactive-value": "N",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_57,
          _hoisted_58
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.valorMO,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.configLoja.valorMO) = $event)),
              class: "ml-2",
              "active-value": "S",
              "inactive-value": "N",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_62,
          _hoisted_63
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.oleoFracionado,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.configLoja.oleoFracionado) = $event)),
              class: "ml-2",
              "active-value": "S",
              "inactive-value": "N",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_67,
          _hoisted_68
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.estoqueNegativo,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.configLoja.estoqueNegativo) = $event)),
              class: "ml-2",
              "active-value": "S",
              "inactive-value": "N",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_72,
          _hoisted_73
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.podeDesconto,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.configLoja.podeDesconto) = $event)),
              class: "ml-2",
              "active-value": "Sim",
              "inactive-value": "Não",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_77,
          _hoisted_78,
          (_ctx.configLoja.podeDesconto === 'Sim')
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", _hoisted_81, [
                  _createVNode(_component_el_input_number, {
                    class: "col-8",
                    "controls-position": "right",
                    min: 0,
                    max: 99,
                    modelValue: _ctx.configLoja.maximoDesconto,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.configLoja.maximoDesconto) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_82
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.habilitadaVoucher,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.configLoja.habilitadaVoucher) = $event)),
              class: "ml-2",
              "active-value": "S",
              "inactive-value": "N",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_86,
          _hoisted_87
        ]),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.habilitadaCampanha,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.configLoja.habilitadaCampanha) = $event)),
              class: "ml-2",
              "active-value": "S",
              "inactive-value": "N",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_91,
          _hoisted_92
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _hoisted_95,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.configLoja.assinaturaCliente,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.configLoja.assinaturaCliente) = $event)),
              class: "ml-2",
              "active-value": "S",
              "inactive-value": "N",
              style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_96,
          _hoisted_97
        ])
      ]),
      _hoisted_98
    ])
  ]))
}